import { moduleState } from 'cerebral'
import { crudActions } from '../factories'

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'geofenceRegions' })

export const toggleActive = async ({ props: { id }, geofenceRegionsService: service, get }) => {
  if (id) {
    const active = get(moduleState`entities.${id}.active`)
    const data = await service.patch(id, { active: !active })
    return { entities: { geofenceRegions: [data] } }
  }
}

export const showOnMap = ({ props, store }) => {
  const { show, id } = props
  store.set(moduleState`shownOnMap.${id}`, show)
}
